<template>
  <div class="AddInstruction lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddInstruction-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddInstruction-main lxn-pos-rel">
      <div class="AddInstruction-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddInstruction_title1}}
          </template>
          <template v-slot:body>
            <div class="AddInstruction-wrapper-colors lxn-w100">
              <div @click="activeBoxIndex = 0;" class="AddInstruction-color color1 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(0)" :class="isBoxActive(0)">
                <div class="AddInstruction-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 1;" class="AddInstruction-color color2 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(1)" :class="isBoxActive(1)">
                <div class="AddInstruction-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 2;" class="AddInstruction-color color3 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(2)" :class="isBoxActive(2)">
                <div class="AddInstruction-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 3;" class="AddInstruction-color color4 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(3)" :class="isBoxActive(3)">
                <div class="AddInstruction-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
              <div @click="activeBoxIndex = 4;" class="AddInstruction-color color5 lxn-h100 lxn-border-round lxn-float-right" :style="boxStyle(4)" :class="isBoxActive(4)">
                <div class="AddInstruction-selectedColor lxn-w100 lxn-h100 lxn-border-round">
                </div>
              </div>
            </div>
            <div class="AddInstruction-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddInstruction_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="InstructionName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.Instruction_namePlaceHolder" inputType="text" />
            </div>
            <div class="AddInstruction-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddInstruction_text2}}
            </div>
            <div class="lxn-w100">
              <DropDown v-model="targetHub" :dropDownContex="dropDownTargetHub" />
            </div>
          </template>
        </TitleBox>
        <Instruction ref="conditions" :instructionId="instructionId" :titleBgColor="titleBgColor" :condition="condition" :targetHub="targetHub" :bgColor="'#ECECEC'"></Instruction>
      </div>
      <div class="AddInstruction-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddInstruction_button}}
        </CustomButton>
      </div>
      <div v-if="isEdit" class="AddSchedule-button lxn-margin-auto lxn-w100">
        <CustomButton @click="deleteInstruction" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddSchedule_button3}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import DropDown from '@/components/DropDown.vue'
import NumberInputSpinner from '@/components/NumberInputSpinner.vue'
import AcRemoteController from '@/components/Home/Devices/AcRemoteController.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import Instruction from "@/components/Instruction/Instruction";

var messaging = new Messaging(new Logger(false));

export default {
  name: 'AddInstruction',
  components: {
    Instruction,
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
    ButtonIcon,
    DropDown,
    NumberInputSpinner,
    AcRemoteController
  },
  data: function () {
    return {
      instructionId: parseInt(this.$route.params.instructionId) || null,
      isEdit: this.$route.params.instructionId !== undefined,
      InstructionName: '',
      condition: {type: 0, conditions: []},
      input1State: '',
      activeBoxIndex: 0,
      outputState: 0,
      targetType: 0,
      targetHub: 0,
    }
  },
  mounted: function () {
    if (this.isEdit){
      this.$store.commit('setAppBusy', true);
      setTimeout(() => {
        const instruction = this.$store.state.instructions.find(x => x.instructionId === this.instructionId)
        this.getHubInstructions(instruction);
      }, 2000)
    }
  },
  watch: {
  },
  computed: {
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.activeBoxIndex];
    },
    dropDownTargetHub: function () {
      var dropDownTargetHub = {
        name: "AddInstructions-TargetHubs",
        title: this.$store.getters.language.texts.AddInstruction_text2,
        selectedIndex: this.targetHub,
        data: []
      };
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        dropDownTargetHub.data.push({
          name: this.$store.state.hubs[i].name,
          icon: "hub",
        })
      }
      return dropDownTargetHub;
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    isBoxActive: function (boxIndex) {
      if(this.activeBoxIndex == boxIndex) {
        return 'active';
      }else{
        return '';
      }
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.InstructionName === ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.AddInstruction_alert1);
      }else {
        const condition = this.$refs.conditions.getData();
        if (condition === null){
          return;
        }
        this.$store.commit('setAppBusy', true);
        const hub = this.$store.state.hubs[this.targetHub];
        const messagingHook = new Messaging(new Logger(false));
        messagingHook.init({
          psk: hub.psk,
          destinationUUID: hub.uuid,
          sourceUUID: this.$store.state.user.uuid
        });

        const instruction = {
          name: this.InstructionName,
          color: this.activeBoxIndex,
          hubUUID: hub.uuid,
          instructions: [condition]
        };
        this.$store.dispatch('setInstructionsOnHub', {
          messagingHook: messagingHook,
          hubUUID: hub.uuid,
          instructions: instruction.instructions,
        })
            .then( (response) => {
              this.$store.commit(this.isEdit ? 'updateInstruction' : 'addInstruction', {
                name: instruction.name,
                color: instruction.color,
                hubUUID: hub.uuid,
                instructionId: condition.instructionId,
              });
              this.$store.commit("saveState");
              this.$router.push('/instructions');
            })
            .catch(response => {
              if(response.rejectCode === 2){
                this.$store.commit('setHubStatus', {
                  hubIndex: response.hubIndex,
                  connectionStatus: {
                    local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                    online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  },
                });
              }
              this.$store.commit('setAppBusy', false);
            })
      }
    },
    getHubInstructions: function (instructionState) {
      const hub = this.$store.state.hubs.find(x => x.uuid === instructionState.hubUUID);
      const psk = hub.psk;
      const destinationUUID = hub.uuid;
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('readHubInstructions', {
        messagingHook: messagingHook,
        hubUUID: destinationUUID,
      })
          .then(response => {
            const instruction = response.body.bodyContent.instructionList.find(x => x.instructionId === this.instructionId);
            this.InstructionName = instructionState.name;
            this.activeBoxIndex = instructionState.color;
            this.targetHub = hub.index;
            this.$refs.conditions.setData(instruction);
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode === 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
              this.$store.commit('setAppBusy', false);
            }
          });
    },
    deleteInstruction: async function () {
      const hub = this.$store.state.hubs[this.targetHub];
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('removeHubInstruction', {
        messagingHook: messagingHook,
        hubUUID: hub.uuid,
        instructions: [this.instructionId],
      })
          .then( () => {
            this.$store.commit('deleteInstruction', this.instructionId);
            this.$store.commit("saveState");
            this.$router.push('/instructions');
            this.$store.commit('setAppBusy', false);
          })
          .catch(response => {
            if(response.rejectCode === 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$store.commit('setAppBusy', false);
          })
    },
  }
}
</script>

<style>
  .AddInstruction-topCurve-wrapper {
    height: 200px;
  }
  .AddInstruction-main {
    z-index: 2;
  }
  .AddInstruction-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .AddInstruction-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .AddInstruction-wrapper-colors {
    height: 50px;
  }
  .AddInstruction-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .AddInstruction-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .AddInstruction-color.active .AddInstruction-selectedColor {
    opacity: 1;
  }
  .AddInstruction-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .AddInstruction-wrapper-name-text {
    height: 50px;
    padding-top: 20px;
    line-height: 30px;
    color: #52626C;
  }
  .AddInstruction-wrapper-padding-0 {
    padding: 0;
    height: unset;
  }
  .AddInstruction-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .AddInstruction-commandDelay-button {
    -webkit-appearance: none;
    transition: opacity 0.5s ease;
    background: #1EA5DE;
    border: 0;
    border-radius: 7px;
    overflow: hidden;
    color: #fff;
    cursor: pointer;
    float: left;
    font-size: 20px;
    height: 40px;
    margin: 0;
    width: 40px;
  }
  .AddInstruction-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddInstruction-commandDelay-button:hover {
    opacity: 0.5;
  }
  .AddInstruction-commandDelay-button:focus {
      outline: 0;
      outline-offset: 0;
  }
  .AddInstruction-wrapper-button2 {
    width: calc(100% - 36px);
    margin-top: 25px;
    margin-bottom: 14px;
  }
  .AddInstruction-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .AddInstruction-wrapper-commands:first-child {
    margin-top: 0;
  }
  .AddInstruction-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .AddInstruction-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
